import React, { useRef } from 'react';

export interface QuoteOtpInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  error?: string;
}

export const QuoteOtpInput: React.FC<QuoteOtpInputProps> = ({
  value,
  onChange,
  disabled = false,
  error,
}) => {
  const inputsRef = useRef<Array<HTMLInputElement | null>>([]);
  const digits = value.padEnd(6, ' ').slice(0, 6).split('');

  const updateDigit = (index: number, nextValue: string) => {
    const cleanValue = nextValue.replace(/\D/g, '');
    if (cleanValue.length > 1) {
      const nextDigits = digits.map((item) => (item === ' ' ? '' : item));
      cleanValue
        .slice(0, 6 - index)
        .split('')
        .forEach((digit, offset) => {
          nextDigits[index + offset] = digit;
        });
      const nextOtp = nextDigits.join('').slice(0, 6);
      onChange(nextOtp);
      inputsRef.current[Math.min(index + cleanValue.length, 5)]?.focus();
      return;
    }

    const digit = cleanValue.slice(-1);
    const nextDigits = digits.map((item) => (item === ' ' ? '' : item));
    nextDigits[index] = digit;
    onChange(nextDigits.join('').slice(0, 6));
    if (digit && index < 5) inputsRef.current[index + 1]?.focus();
  };

  return (
    <div>
      <div className="grid grid-cols-6 gap-2 sm:gap-3">
        {digits.map((digit, index) => (
          <input
            key={index}
            ref={(node) => {
              inputsRef.current[index] = node;
            }}
            inputMode="numeric"
            autoComplete={index === 0 ? 'one-time-code' : 'off'}
            disabled={disabled}
            value={digit === ' ' ? '' : digit}
            onChange={(event) => updateDigit(index, event.target.value)}
            onKeyDown={(event) => {
              if (event.key === 'Backspace' && !digits[index].trim() && index > 0) {
                inputsRef.current[index - 1]?.focus();
              }
            }}
            onPaste={(event) => {
              event.preventDefault();
              const pasted = event.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
              if (pasted) onChange(pasted);
            }}
            className={`h-12 rounded-xl border bg-slate-950/70 text-center text-lg font-bold text-white outline-none transition-colors focus:border-brand-500 focus:ring-1 focus:ring-brand-500 sm:h-14 ${
              error ? 'border-red-500' : 'border-slate-700'
            }`}
            aria-label={`Doğrulama kodu ${index + 1}. hane`}
          />
        ))}
      </div>
      {error && <p className="mt-2 text-sm text-red-400">{error}</p>}
    </div>
  );
};
